module.exports = __webpack_public_path__ + "img/agents-grouped.f3d5828a.png";